import type { RenderProps } from 'hb-builder/components/common/type/RenderProps';
import { Wrapper } from 'hb-builder/components/common/Wrapper/WrapperRender';
import { useRendererContext } from 'hb-builder/hooks';
import type { RenderComponent } from 'hb-builder/types';
import { getJustifyContent, hasLink } from 'hb-builder/utils/attributes';
import type { DocumentItem } from 'hb-react/backoffice/types/builder/builderDocument';
import type { PageImageItemAttributes } from 'hb-react/backoffice/types/builder/itemAttributes/pageImageItemAttributess';

import ResizedImageUi from './ResizedImageUi';

const componentType = 'single';

const PageImage: RenderComponent = () => <div />; // never used

const Render = ({
  item,
}: RenderProps<DocumentItem<PageImageItemAttributes>>) => {
  const { isMobilePreview } = useRendererContext();

  if (!item || !item.attributes) {
    return null;
  }

  const { attributes } = item;

  return (
    // @ts-expect-error untyped
    <Wrapper
      attributes={attributes}
      componentType={componentType}
      dataTestId="builder-component-image"
      isMobilePreview={isMobilePreview}
      style={{
        // Safari's default setting for the align-items is stretch
        alignItems: 'flex-start',
        justifyContent: getJustifyContent(attributes?.horizontalAlign),
      }}
    >
      <ResizedImageUi
        attributes={attributes}
        hasLink={hasLink({ link: attributes?.imageLink })}
      />
    </Wrapper>
  );
};

PageImage.componentName = 'PageImage';
PageImage.Render = Render;

export default PageImage;
